import { useEffect } from 'react';
import { Modal } from 'src/components/Common/@electron/Modal';
import { RichText } from 'src/components/Common/@electron/RichText';
import { toKebabCase } from 'src/lib/Utils/helpers';
import { ImagesType } from '..';

type OfferRebateModalProps = {
  code?: string;
  title?: string;
  description?: string;
  details?: string;
  defaultMeasureCategory?: string;
  learnMore?: string;
  rebate?: string;
  rebateAmount?: string;
  img?: string;
  images: ImagesType;
  primaryButton?: { text: string; link: string };
  secondaryButton?: { text: string; link: string };
};

const ModalImage = ({ images, defaultMeasureCategory }: any) => {
  if (images) {
    return <img src={images[defaultMeasureCategory]?.icon || ''} alt="" className="icon-122" />;
  }

  return null;
};

const ModalDescription = ({ description, details }: any) => {
  if (description || details) {
    return (
      <div id="modal-description" className="text-center mt-12">
        <RichText value={details || description} />
      </div>
    );
  }

  return null;
};

const OfferRebateModal = ({
  title,
  description,
  details,
  images,
  learnMore,
  showModal,
  code,
  defaultMeasureCategory,
  rebate,
  rebateAmount,
  sendModalAnalytics,
  closeModal,
}: OfferRebateModalProps & {
  showModal: boolean;
  closeModal: () => void;
  sendModalAnalytics?: (
    action: 'load' | 'clickthrough',
    modalTitle?: string,
    offerCode?: string
  ) => void;
}) => {
  useEffect(() => {
    if (showModal) {
      sendModalAnalytics?.('load', title, code);
    }
  }, [showModal]);

  return (
    <Modal
      onClose={closeModal}
      isOpen={showModal}
      id={`${toKebabCase(title)}Modal`}
      title={<ModalImage images={images} defaultMeasureCategory={defaultMeasureCategory} />}
      titleVariant="text-center"
      description={
        <h2 id="modal-title" className="text-2xl text-gray-darker mt-16">
          {title}
        </h2>
      }
      descriptionVariant="text-center"
    >
      <ModalDescription description={description} details={details} />
      <div className="mt-24 mb-12 md:mb-0">
        <div className="flex flex-col justify-center max-w-2xs mx-auto">
          <a
            href={`/find-a-contractor?fidService=${defaultMeasureCategory}&offerCode=${
              code || ''
            }&rebate=${rebate || ''}&rebateAmount=${rebateAmount || ''}`}
            className="btn btn-primary btn-full"
            type="button"
            onClick={() => sendModalAnalytics?.('clickthrough', title, code)}
          >
            {code ? 'GET OFFER' : 'GET REBATE'}
          </a>
          {learnMore && (
            <a
              href={learnMore}
              className="mt-24 text-teal-darker mx-auto underline hover:no-underline text-center"
            >
              LEARN MORE
            </a>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default OfferRebateModal;
export { type OfferRebateModalProps };
